import axios from 'axios';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const VerifyEmail = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const verifyEmail = localStorage.getItem('verifyEmail')

    const [errors, setErrors] = useState({});
    const [inputValue, setInputValue] = useState({
        code: ""
    });
    const inputHandler = (e) => {
        const { name, value } = e.target;
        setInputValue({
            ...inputValue,
            [name]: value.trim()
        })
    }

    const validate = () => {
        let errors = {};

        if (!inputValue.code) {
            errors.code = "Code is required"
        }

        return errors;
    };

    const submitForm = async (e) => {
        e.preventDefault()

        const formErrors = validate();
        setErrors(formErrors);

        const apiData = {
            email: verifyEmail,
            otp: inputValue.code
        }

        if (Object.keys(formErrors).length === 0) {
            try {
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/verify-otp`, apiData)
                const data = await response.data

                if (data.status === 1) {
                    toast.success(data.message)
                    localStorage.removeItem('verifyEmail')
                    localStorage.setItem('verifyId', data.result._id)
                    navigate('/recover-password')
                } else {
                    toast.error(data.message)
                }
            } catch (error) {
                console.log('Error:', error)
            }
        }
    }

    const [timeLeft, setTimeLeft] = useState(60);
    const [canResend, setCanResend] = useState(false);

    useEffect(() => {
        if (timeLeft > 0) {
        const timer = setTimeout(() => {
            setTimeLeft((prev) => prev - 1);
        }, 1000);
        return () => clearTimeout(timer);
        } else {
        setCanResend(true);
        }
    }, [timeLeft]);

    const handleResend = () => {
        resendEmail();
        setTimeLeft(60);
        setCanResend(false);
    };
    const formatTime = (seconds) => {
        const m = String(Math.floor(seconds / 60)).padStart(2, "0");
        const s = String(seconds % 60).padStart(2, "0");
        return `${m}:${s}`;
    };
    
    const resendEmail = async () => {
        const apiData = {
            email: verifyEmail
        }
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/forgot-password`, apiData)
            const data = await response.data

            if (data.status === 1) {
                toast.success(data.message)
            } else {
                toast.error(data.message)
            }

        } catch (error) {
            console.log('Error:', error)
        }
    }

    return (
        <>
            <div className='main-content'>
                <div className='padding login-section'>
                    <div className='container'>
                        <div className='login-box mx-auto'>
                            <h4 className='text-center mb-3'>{t('Check Your Inbox')}</h4>
                            <p className='text-center mb-1'>{t('Enter Code To Email')}</p>
                            <p className='text-center mb-5 text-main'>{verifyEmail}</p>

                            <form action="" className='form form1' onSubmit={submitForm}>
                                <div className='mb-3'>
                                    <input type="text" className="form-control" placeholder={t('Enter Code')} name="code" onChange={inputHandler} />
                                    {errors.code && <p className="error-text">{errors.code}</p>}
                                </div>

                                <div className="text-center mt-4">
                                    <p className="mb-2">
                                        {t("Time left")}: <span className="text-white">{formatTime(timeLeft)}</span>
                                    </p>
                                    {!canResend ? (
                                        <>
                                            <p className="mb-0">{t("Resend the code")}</p>
                                        </>
                                    ) : (
                                        <p>
                                            <Link className="text-white mb-0" onClick={handleResend}>
                                                {t("Resend the code")}
                                            </Link>
                                        </p>
                                    )}
                                </div>

                                <div className='mt-3'>
                                    <button type='submit' className='btn btn1 w-100 mt-4'>{t("Next")}</button>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default VerifyEmail
